
class GMaps {
    /**
     * Create a new GMaps instance.
     *
     * @param {object} data
     */
    constructor(opt) {
        this.lat = opt.lat;
        this.lng = opt.lng;
        this.latDefault = 46.0122;
        this.lngDefault = 13.565;
        this.zoom = 15;
        this.mapName = opt.name;
        this.mapElName = 'google-map';
        this.map = null;
    }

    getLat() {
        // console.log('lat: ', this.lat);
        return parseFloat(this.lat) || this.latDefault;
    }

    getLng() {
        return parseFloat(this.lng) || this.lngDefault;
    }

    getZoom() {
        return parseInt(this.zoom);
    }

    drawMap() {

        const myLatLng = {lat: parseFloat(this.getLat()), lng: parseFloat(this.getLng())};
        const element = document.getElementById(this.mapElName);
        if(element !== null || element !== undefined) {
          const options = {
            center: myLatLng,
            zoom: this.getZoom(),
            mapTypeControlOptions: {
              mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain',
                      'styled_map']
            }
          }
        this.map = new google.maps.Map(element, options);

        this.addMarker(myLatLng);
        //Associate the styled map with the MapTypeId and set it to display.
        this.map.mapTypes.set('styled_map', this.styledMapType());
        this.map.setMapTypeId('styled_map');
        } else {
          console.log('elem is undefined !!!!!');
        }
        // console.log('GMaps lat lng ', this.lat, markerCoordinates[0], this.lat, this.lng);
    }

    styledMapType() {
        return new google.maps.StyledMapType(
            [
              {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
              {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
              {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
              {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [{color: '#c9b2a6'}]
              },
              {
                featureType: 'administrative.land_parcel',
                elementType: 'geometry.stroke',
                stylers: [{color: '#dcd2be'}]
              },
              {
                featureType: 'administrative.land_parcel',
                elementType: 'labels.text.fill',
                stylers: [{color: '#ae9e90'}]
              },
              {
                featureType: 'landscape.natural',
                elementType: 'geometry',
                stylers: [{color: '#fff'}]
              },
              {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [{color: '#fff'}]
              },
              {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [{color: '#93817c'}]
              },
              {
                featureType: 'poi.park',
                elementType: 'geometry.fill',
                stylers: [{color: '#a5b076'}]
              },
              {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [{color: '#447530'}]
              },
              {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{color: '#f5f1e6'}]
              },
              {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [{color: '#fdfcf8'}]
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{color: '#f8c967'}]
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [{color: '#e9bc62'}]
              },
              {
                featureType: 'road.highway.controlled_access',
                elementType: 'geometry',
                stylers: [{color: '#e98d58'}]
              },
              {
                featureType: 'road.highway.controlled_access',
                elementType: 'geometry.stroke',
                stylers: [{color: '#db8555'}]
              },
              {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [{color: '#806b63'}]
              },
              {
                featureType: 'transit.line',
                elementType: 'geometry',
                stylers: [{color: '#fff'}]
              },
              {
                featureType: 'transit.line',
                elementType: 'labels.text.fill',
                stylers: [{color: '#8f7d77'}]
              },
              {
                featureType: 'transit.line',
                elementType: 'labels.text.stroke',
                stylers: [{color: '#ebe3cd'}]
              },
              {
                featureType: 'transit.station',
                elementType: 'geometry',
                stylers: [{color: '#fff'}]
              },
              {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [{color: '#b9d3c2'}]
              },
              {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{color: '#92998d'}]
              }
            ],
            {name: 'Stiliziran'});
        // #fff = #dfd2ae
    }
    markerIcon() {
        // Star
        return {
          path: 'M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z',
          fillColor: 'lime',
          fillOpacity: 0.8,
          scale: 0.1,
          strokeColor: 'rgba(0,0,0,0.6)',
          strokeWeight: 3
        };
    }
    addMarker(location) {
        var marker = new google.maps.Marker({
          position: location,
          map: this.map,
          icon: this.markerIcon(),
          title: this.mapName
        });
      }

/* -------- end of class ---------- */
}

export default GMaps;


// WEBPACK FOOTER //
// ./src/components/elements/gmaps/GoogleMaps.js